import { EventEmitter, Injectable, Output } from '@angular/core';
@Injectable()
export class LoginAuthenticationScreenExtendedComponent {
  @Output() redirectTrackingClick: EventEmitter<string> =
    new EventEmitter<string>();

  myTrip = false;
  needHelp = false;
  onRedirectTracking(viewName: string): void {
    this.redirectTrackingClick.emit(viewName);
  }

  addNeedHelpEventListener(message: string): string {
    setTimeout(() => {
      const formAlertElement =
        document.getElementsByTagName('idp-form-alert')[0];

      if (formAlertElement) {
        const anchors = formAlertElement.querySelector('a');
        if (anchors) {
          this.emitNeedHelp(anchors);
          this.emitMyTrip(anchors);
        }
      }
    }, 100);
    return message;
  }

  emitNeedHelp(anchors): void {
    if (anchors.href.includes('support-skymiles')) {
      anchors.addEventListener('click', (event) => {
        if (event && !this.needHelp) {
          this.needHelp = true;
          this.redirectTrackingClick.emit('needHelp');
        }
      });
    }
  }

  emitMyTrip(anchors): void {
    if (anchors.href.includes('my-trips/search')) {
      anchors.addEventListener('click', (event) => {
        if (event && !this.myTrip) {
          this.myTrip = true;
          this.redirectTrackingClick.emit('myTrips');
        }
      });
    }
  }
}
